import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Button from '../Parts/Button';
import Typography from 'material-ui/Typography'
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import ArrowDropdown from '../Icons/ArrowDropdown';
import Add from '../Icons/Add';
import MuiButton from 'material-ui/Button';
import HelpIcon from "../Icons/HelpIcon";
import ArrowToolTip from "../common/ArrowToolTip";

const sectionMenu = {
  section: {
    width: '100%',
    marginBottom: '50px',
    position: 'relative',
  },

  collapsed: {
    maxHeight: '200px',
    overflowY: 'hidden',
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #D8DBDF',
    paddingBottom: '5px',
    position: 'relative',
    cursor: 'pointer',
    marginBottom: '20px',
    '&:hover': {
      '& $arrow': {
        visibility: 'visible',
        opacity: 1
      }
    }
  },

  sectionBody: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    marginTop: '8px',
  },

  radioControl: {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'flex-start',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  entry: {
    width: '100%',
    marginTop: '8px',
    display: 'inline-flex',
    alignItems: 'flex-start',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  arrow: {
    transform: 'translateX(-100%)',
    position: 'absolute',
    left: 0,
    visibility: 'hidden',
    opacity: 0,
    width: 'unset',
    height: 'unset',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  text: {
    marginLeft: '5px',
    fontSize: '14px',
    wordBreak: 'break-all',
    flex: 1,
  },

  expandBtnContainer: {
    width: '100%',
    height: '60px',
    position: 'absolute',
    bottom: 0,
  },

  gradient: {
    width: '100%',
    height: '37px',
    background: 'linear-gradient(transparent 0%, white 80%)'
  },

  expandBtnOutter: {
    height: '23px',
    background: '#FFFFFF',
    padding: '0px 4px',
    boxSizing: 'border-box',
  },

  button: {
    color: '#1A65FF',
    fontSize: '11px',
    minHeight: 'unset',
    padding: '6px 8px',
  },

  divider: {
    borderLeft: '1px solid #D8DBDF',
    height: '11px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
  }
}

class Section extends React.Component {
  state = {
    open: true,
    collapsed: true,
  }

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  handleExpand = () => {
    this.setState({
      collapsed: false
    })
  }

  renderExpandBtn = () => {
    const { classes, menuItems, disabled } = this.props;

    const displayItemCount = 5;
    if (menuItems && menuItems.length > displayItemCount && this.state.collapsed) {
      return (
        <div className={classes.expandBtnContainer}>
          <div className={classes.gradient}></div>
          <div className={classes.expandBtnOutter}>
            <MuiButton color="default" className={classes.button} style={{ color: disabled ? '#B1B3B9' : '#1A65FF' }} onClick={this.handleExpand}>
              <Add width={10} height={10} color={disabled ? '#B1B3B9' : '#1A65FF'} />
              さらに表示
            </MuiButton>
          </div>
        </div>
      )
    }
  }

  render() {
    const {
      classes,
      title,
      menuItems,
      selectAll,
      deselectAll,
      select,
      set,
      disabled,
      tooltipText,
      children,
      controls,
      toolTipPlacement,
      radioControl,
      ...rest
    } = this.props;

    const displayItemCount = 5;
    let collapsed = menuItems && menuItems.length > displayItemCount && this.state.collapsed;
    return (
      <div className={classes.section} {...rest}>
        <div className={classes.sectionHeader}>
          <IconButton
            className={classes.arrow}
            style={{ transform: this.state.open ? 'translateX(-100%) rotate(0deg)' : 'translateX(-100%) rotate(-90deg)' }}
            onClick={this.handleClick}
          >
            <ArrowDropdown color="#71737B" width={20} height={20} />
          </IconButton>

          <Typography
            variant="body2"
            style={{ color: disabled ? '#B1B3B9' : '#181819', 'flex': 1, fontWeight: 'bold' }}
            onClick={this.handleClick}
          >
            {title}
            {/* タイトルに対して子のオプションがないSectionでNewラベルを表示したいときは、src/constants/SidebarValues.jsのdummyMenuForTitleNewを使ってください。 */}
            {(menuItems && menuItems.filter(item => item.isNew === true).length > 0) && (
              <div className={classes.newLabel} style={{ display: 'inline-block', lineHeight: 'normal' }}>NEW</div>
            )}
            {(tooltipText && (
              <div style={{ display: 'inline-block', lineHeight: 'normal', marginLeft: '2px', marginBottom: '3px', verticalAlign: 'middle' }}>
                <ArrowToolTip
                  text={tooltipText}
                  tooltipMaxWidth={"200"}
                  placement={toolTipPlacement}
                >
                  <HelpIcon
                    width={16}
                    height={16}
                    color="#71737B"
                  />
                </ArrowToolTip>
              </div>
            ))}
          </Typography>

          {(() => {
            if (deselectAll && selectAll) {
              return (
                <Button
                  text={set && set.count() === 0 ? "全選択" : "選択解除"}
                  type="ghost"
                  size="extra-small"
                  handleClickButton={set && set.count() === 0 ? selectAll : deselectAll}
                  style={{
                    color: disabled ? '#B1B3B9' : '#71737B',
                    border: 'none',
                    minWidth: 'unset',
                    width: 'unset',
                    padding: '0px 5px',
                  }}
                />
              )
            } else if (deselectAll) {
              return (
                <Button
                  text="リセット"
                  type="ghost"
                  size="extra-small"
                  handleClickButton={deselectAll}
                  style={{
                    color: disabled ? '#B1B3B9' : '#71737B',
                    border: 'none',
                    minWidth: 'unset',
                    width: 'unset',
                    padding: '0px 5px',
                  }}
                />
              )
            }
          })()}

          {(() => {
            if (controls) {
              return controls.map((control, i) => (
                <div className={classes.divider} key={i}>
                  <Button
                    text={control.text}
                    type="ghost"
                    size="extra-small"
                    handleClickButton={control.action}
                    style={{
                      color: disabled ? '#B1B3B9' : '#71737B',
                      border: 'none',
                      minWidth: 'unset',
                      width: 'unset',
                      padding: '0px 5px',
                    }}
                  />
                </div>
              ))
            }
          })()}

        </div>

        <div className={classNames(classes.sectionBody, collapsed ? classes.collapsed : '')} style={{ display: this.state.open ? 'flex' : 'none' }}>
          {(() => {
            if (menuItems === undefined || children) {
              return children
            } else if (menuItems.length === 0) {
              return (
                <div className={classes.entry}>
                  {this.props.empty ? this.props.empty : <Typography variant="subheading" style={{ color: disabled ? '#B1B3B9' : '#71737B' }}>{title}がありません</Typography>}
                </div>
              )
            } else {
              return (
                <React.Fragment>
                  {radioControl && (
                    <div className={classes.radioControl}>
                      {radioControl}
                    </div>
                  )}
                  {menuItems.map((item, i) => (
                    <div key={i}
                      className={classes.entry}
                      style={{ cursor: 'pointer' }}
                      onClick={() => select((item.id || item.value).toString())}>
                      <Checkbox
                        color="primary"
                        checked={set.includes((item.id || item.value).toString())}
                        style={{
                          width: '20px',
                          height: '20px',
                        }}
                        value={(item.id || item.value).toString()}
                        onChange={() => select((item.id || item.value).toString())}
                        disabled={disabled}
                      />
                      <Typography
                        variant="subheading"
                        className={classes.text}
                        style={{ color: disabled ? '#B1B3B9' : '#181819' }}>
                        {item.name}
                      </Typography>
                      {!!item.isNew && (
                        <div className={classes.newLabel}>NEW</div>
                      )}
                    </div>
                  ))}
                </React.Fragment>
              )
            }
          })()}
          {this.renderExpandBtn()}
        </div>
      </div>
    )
  }
}

Section.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  menuItems: PropTypes.array, // src/constants/SidebarValues.jsのdummyMenuForTitleNew
  deselectAll: PropTypes.func,
  selectAll: PropTypes.func,
  select: PropTypes.func,
  set: PropTypes.object,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
  toolTipPlacement: PropTypes.string,
  children: PropTypes.node,
  controls: PropTypes.array,
  empty: PropTypes.node,
  radioControl: PropTypes.node,
};

Section.defaultProps = {
  tooltipText: null,
  toolTipPlacement: 'top',
}

export default withStyles(sectionMenu)(Section);



// WEBPACK FOOTER //
// ./src/components/common/Section.jsx